import React, { useState, useEffect } from "react";
import PublicNavbar from "../../components/Navbars/PublicNavbar";
import AuthFooter from "../../components/Footers/AuthFooter";
import {
  Container,
  Table,
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { phoneEmailUrlClickCount } from "../../http/http-calls";
import { copyToClipboard, showToast } from "../../helper-methods";
import { BASE_URL } from "../../config";
import axios from "axios";
import Swal from "sweetalert2";

const ServiceList = () => {
  const location = useLocation();
  const [isDisabled, setIsDisabled] = useState(false);
  const [expandedRows, setExpandedRows] = useState([]);

  useEffect(() => {
    let syncTableToTop,
      handleMouseDown,
      handleMouseMove,
      handleMouseUp,
      handleClick;
    let isDragging = false;
    let startX = 0;
    let startScrollLeft = 0;
    let tableContainer = null;
    let customScrollbar = null;
    let scrollbarThumb = null;

    const syncScrollbars = () => {
      customScrollbar = document.querySelector(".always-visible-scrollbar");
      scrollbarThumb = document.querySelector(".scrollbar-thumb");
      tableContainer = document.querySelector(".table-scroll-container");
      const table = document.querySelector(".table-scroll-container table");

      if (customScrollbar && scrollbarThumb && tableContainer && table) {
        // Calculate thumb position and size based on table scroll
        const updateThumbPosition = () => {
          // Recalculate dimensions dynamically in case table resized
          const currentTableWidth = table.scrollWidth;
          const currentContainerWidth = tableContainer.clientWidth;
          const scrollbarWidth = customScrollbar.clientWidth;
          const scrollLeft = tableContainer.scrollLeft;
          const maxScroll = currentTableWidth - currentContainerWidth;
          const thumbMaxPosition = scrollbarWidth - scrollbarThumb.offsetWidth;

          if (maxScroll > 0) {
            const thumbPosition = (scrollLeft / maxScroll) * thumbMaxPosition;
            const thumbSize = Math.max(
              40,
              (currentContainerWidth / currentTableWidth) * scrollbarWidth
            );

            scrollbarThumb.style.left = `${thumbPosition}px`;
            scrollbarThumb.style.width = `${thumbSize}px`;
            scrollbarThumb.style.display = "block";
          } else {
            // Always show thumb even when no scroll needed
            scrollbarThumb.style.left = "0px";
            scrollbarThumb.style.width = "40px";
            scrollbarThumb.style.display = "block";
          }
        };

        // Remove old listeners if they exist before creating new ones
        if (scrollbarThumb && handleMouseDown) {
          scrollbarThumb.removeEventListener("mousedown", handleMouseDown);
        }
        if (customScrollbar && handleClick) {
          customScrollbar.removeEventListener("click", handleClick);
        }
        if (tableContainer && syncTableToTop) {
          tableContainer.removeEventListener("scroll", syncTableToTop);
        }
        if (handleMouseMove) {
          document.removeEventListener("mousemove", handleMouseMove);
        }
        if (handleMouseUp) {
          document.removeEventListener("mouseup", handleMouseUp);
        }

        // Define handlers as closures that capture current values
        handleMouseDown = (e) => {
          isDragging = true;
          startX = e.clientX;
          startScrollLeft = tableContainer.scrollLeft;
          scrollbarThumb.style.cursor = "grabbing";
          e.preventDefault();
        };

        handleMouseMove = (e) => {
          if (!isDragging) return;

          const deltaX = e.clientX - startX;
          const scrollbarWidth = customScrollbar.clientWidth;
          const currentTableWidth = table.scrollWidth;
          const currentContainerWidth = tableContainer.clientWidth;
          const maxScroll = currentTableWidth - currentContainerWidth;

          if (maxScroll > 0) {
            const scrollDelta = (deltaX / scrollbarWidth) * maxScroll;
            const newScrollLeft = startScrollLeft + scrollDelta;
            const clampedScrollLeft = Math.max(
              0,
              Math.min(newScrollLeft, maxScroll)
            );
            tableContainer.scrollLeft = clampedScrollLeft;
          }
        };

        handleMouseUp = () => {
          isDragging = false;
          scrollbarThumb.style.cursor = "pointer";
        };

        handleClick = (e) => {
          if (isDragging) return; // Don't handle click if we were dragging

          const rect = customScrollbar.getBoundingClientRect();
          const clickX = e.clientX - rect.left;
          const scrollbarWidth = customScrollbar.clientWidth;
          const currentTableWidth = table.scrollWidth;
          const currentContainerWidth = tableContainer.clientWidth;
          const maxScroll = currentTableWidth - currentContainerWidth;

          if (maxScroll > 0) {
            const scrollLeft = (clickX / scrollbarWidth) * maxScroll;
            const clampedScrollLeft = Math.max(
              0,
              Math.min(scrollLeft, maxScroll)
            );
            tableContainer.scrollLeft = clampedScrollLeft;
          }
        };

        syncTableToTop = () => {
          updateThumbPosition();
        };

        // Add event listeners
        scrollbarThumb.addEventListener("mousedown", handleMouseDown);
        document.addEventListener("mousemove", handleMouseMove);
        document.addEventListener("mouseup", handleMouseUp);
        customScrollbar.addEventListener("click", handleClick);
        tableContainer.addEventListener("scroll", syncTableToTop);

        // Initial update
        updateThumbPosition();
      }
    };

    // Add a delay to ensure DOM is fully rendered
    const timeoutId = setTimeout(syncScrollbars, 200);

    // Handle window resize
    const handleResize = () => {
      setTimeout(syncScrollbars, 100);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("resize", handleResize);

      // Clean up scroll listeners
      if (scrollbarThumb && handleMouseDown) {
        scrollbarThumb.removeEventListener("mousedown", handleMouseDown);
      }
      if (customScrollbar && handleClick) {
        customScrollbar.removeEventListener("click", handleClick);
      }
      if (tableContainer && syncTableToTop) {
        tableContainer.removeEventListener("scroll", syncTableToTop);
      }
      // Remove global mouse events
      if (handleMouseMove) {
        document.removeEventListener("mousemove", handleMouseMove);
      }
      if (handleMouseUp) {
        document.removeEventListener("mouseup", handleMouseUp);
      }
    };
  }, [location?.state]);

  // console.log("searchList", location.state);

  const _emailPhoneUrlClickHandler = async (type, text) => {
    let newServiceArray = location.selectedServiceId;
    copyToClipboard(text);
    try {
      await phoneEmailUrlClickCount({
        clickType: type,
        service: newServiceArray,
      });
      // console.log("type", res);
      // showToast(
      //   res.message && res.message.length
      //     ? "Success"
      //     : "Provider Added Successfully!",
      //   "success"
      // );
    } catch (error) {
      // console.log("error", error);
      if (error.reason) {
        showToast(
          error.reason && error.reason.length
            ? error.reason
            : "Server error. Try again after sometime.",
          "error"
        );
      }
    }
  };

  const _exportListHandler = async (format) => {
    try {
      if (typeof window !== "undefined" && !isDisabled) {
        setIsDisabled(true);

        const outputFilename =
          format === "xlsx" ? "provider.xlsx" : "provider.pdf";

        const payload = {
          data: location?.state,
          format: format,
        };

        axios
          .post(`${BASE_URL}/download`, payload, {
            responseType: "arraybuffer",
            headers: {
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            const href = URL.createObjectURL(new Blob([response.data]));

            const link = document.createElement("a");
            link.href = href;
            link.setAttribute("download", outputFilename);
            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            URL.revokeObjectURL(href);
          })
          .catch((error) => {
            Swal.fire("Error", "Failed to download file", "warning");
          })
          .finally(() => {
            setIsDisabled(false);
          });
      }
    } catch (error) {
      Swal.fire("Error", error.message, "warning");
      setIsDisabled(false);
    }
  };

  const toggleRowExpansion = (index) => {
    setExpandedRows((prev) => {
      if (prev.includes(index)) {
        return prev.filter((i) => i !== index);
      } else {
        return [...prev, index];
      }
    });
  };

  return (
    <div className="vayco-admin public-protected">
      <style>
        {`
    .hide-scrollbar::-webkit-scrollbar {
      display: none;
    }
    
    /* Hide scrollbar for table container but keep functionality */
    .table-scroll-container::-webkit-scrollbar {
      display: none;
    }
    
    .table-scroll-container {
      -ms-overflow-style: none;  /* IE and Edge */
      scrollbar-width: none;  /* Firefox */
    }
  `}
      </style>
      {/* //Protected Routes */}
      <div className="wrapper">
        <div className="main-panel">
          <PublicNavbar />
          <div className="content">
            <Container fluid className="mobilePadding-0">
              {/* ==== Page Header ===== */}
              <div className="page_Inner_header">
                <div className="page_title gap-2 justify-content-between">
                  <h1 className="space_remove">Your Resources List</h1>

                  {location?.state?.length ? (
                    <UncontrolledButtonDropdown>
                      <DropdownToggle
                        color="primary"
                        caret
                        disabled={isDisabled}
                      >
                        Export List
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem onClick={() => _exportListHandler("pdf")}>
                          As PDF
                        </DropdownItem>
                        <DropdownItem
                          onClick={() => _exportListHandler("xlsx")}
                        >
                          As Excel
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledButtonDropdown>
                  ) : null}
                </div>
              </div>

              <div style={{ position: "relative" }}>
                {/* Always visible scrollbar */}
                <div
                  className="always-visible-scrollbar"
                  style={{
                    width: "100%",
                    height: "12px",
                    marginBottom: "5px",
                    border: "1px solid #dee2e6",
                    borderRadius: "6px",
                    backgroundColor: "#f8f9fa",
                    position: "relative",
                    overflow: "hidden",
                  }}
                >
                  {/* Scrollbar track */}
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      backgroundColor: "#f8f9fa",
                      position: "relative",
                    }}
                  >
                    {/* Scrollbar thumb - always visible */}
                    <div
                      className="scrollbar-thumb"
                      style={{
                        position: "absolute",
                        top: "1px",
                        left: "0px",
                        width: "40px", // Smaller fixed width for thumb
                        height: "10px",
                        backgroundColor: "#6c757d",
                        borderRadius: "5px",
                        cursor: "pointer",
                        transition: "background-color 0.2s",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = "#495057";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor = "#6c757d";
                      }}
                    ></div>
                  </div>
                </div>
                {/* Table container */}
                <div
                  className="table-scroll-container hide-scrollbar"
                  style={{
                    overflowX: "auto",
                    overflowY: "auto",
                    maxHeight: "500px",
                    width: "100%",
                    border: "1px solid #dee2e6",
                    borderRadius: "0.25rem",
                    scrollbarWidth: "none" /* Firefox */,
                    msOverflowStyle: "none" /* IE and Edge */,
                  }}
                >
                  {/* ========= Table ======== */}
                  <Table
                    className="check-switch m-0"
                    style={{
                      minWidth: "1800px",
                      width: "1800px",
                      tableLayout: "fixed",
                    }}
                  >
                    <thead>
                      <tr>
                        <th>Company Name</th>
                        <th style={{ width: "400px" }}>URL</th>
                        <th>Owner</th>
                        <th style={{ width: "350px" }}>Email</th>
                        <th>Phone</th>
                        <th>Address</th>
                        <th>Services</th>
                        <th>ZIP Codes</th>
                        <th>Non-Profit</th>
                        <th>
                          {/* style={{ textTransform: "none !important" }} */}
                          Charge for Services
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {location?.state?.length ? (
                        location?.state?.map((data, index) => (
                          <tr key={index}>
                            <td>
                              {data?.providerName === "CVSO" ? (
                                <img
                                  className="tableImage"
                                  src={require("../../assets/img/verified.png")}
                                  alt="CVSO"
                                />
                              ) : null}
                              {data?.providerName}
                            </td>
                            <td
                            // onClick={() =>
                            //   _emailPhoneUrlClickHandler("url", data?._service)
                            // }
                            // onClick={() =>
                            //   history.push(`/${data?.providerWebsiteUrl}`)
                            // }
                            >
                              {data?.providerWebsiteUrl ? (
                                <a
                                  href={
                                    data?.providerWebsiteUrl.startsWith(
                                      "http://"
                                    ) ||
                                    data?.providerWebsiteUrl.startsWith(
                                      "https://"
                                    )
                                      ? data?.providerWebsiteUrl
                                      : `http://${data?.providerWebsiteUrl}`
                                  }
                                  rel="noreferrer"
                                  target="_blank"
                                  onClick={() =>
                                    _emailPhoneUrlClickHandler(
                                      "url",
                                      data?.providerEmail
                                    )
                                  }
                                >
                                  <i className="fas fa-home mr-1"></i>
                                  {data?.providerWebsiteUrl}
                                </a>
                              ) : null}
                            </td>
                            <td>
                              {data?.contactName?.last === undefined
                                ? data?.contactName?.first
                                : data?.contactName?.first +
                                  " " +
                                  data?.contactName?.last}
                            </td>
                            <td
                              onClick={() =>
                                _emailPhoneUrlClickHandler(
                                  "email",
                                  data?.providerEmail
                                )
                              }
                            >
                              <a
                                href={`mailto: ${data?.providerEmail}`}
                                className="mr-1"
                              >
                                <i className="fas fa-envelope"></i>
                              </a>
                              {data?.providerEmail}
                            </td>
                            <td
                              onClick={() =>
                                _emailPhoneUrlClickHandler(
                                  "phone",
                                  data?.providerPhone
                                )
                              }
                            >
                              <a
                                href={`tel: ${data?.providerPhone}`}
                                className="mr-1"
                              >
                                <i className="fas fa-phone"></i>
                              </a>
                              {data?.providerPhone}
                            </td>
                            <td>{data?.providerAddress}</td>
                            <td>
                              {" "}
                              {data?._service
                                ?.map((item) => item.serviceName)
                                .join(", ")}
                            </td>
                            <td>
                              {expandedRows.includes(index)
                                ? data?.zipcode?.join(", ")
                                : data?.zipcode?.slice(0, 2).join(", ")}
                              {data?.zipcode.length > 2 && (
                                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                <a
                                  style={{
                                    cursor: "pointer",
                                    marginLeft: "5px",
                                  }}
                                  onClick={() => toggleRowExpansion(index)}
                                >
                                  {expandedRows.includes(index)
                                    ? "See Less"
                                    : "See More"}
                                </a>
                              )}
                            </td>
                            <td>{data?.isNonProfit ? "Yes" : "No"}</td>
                            <td>{data?.isChargeable ? "Yes" : "No"}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={10}>
                            <div className="noData">
                              <img
                                src={
                                  require("../../assets/img/noData.svg").default
                                }
                                alt="no data"
                              />
                              <p>There is no data to display</p>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </div>

              <div
                className="d-flex justify-content-sm-between align-items-start text-center mt-5 flex-wrap justify-content-center"
                style={{ gap: "15px" }}
              >
                <Link to="/service-selection" className="btn btn-secondary">
                  New Search
                </Link>
                {/* <a
                  rel="noreferrer"
                  className="btn-primary"
                  target="_blank"
                  href="https://www.in.gov/dva/idva-vet-connect/"
                >
                  Request More Info from IDVA
                </a> */}
              </div>
              {/* <p
                className="fs-14 mt-2 text-sm-right text-center"
                style={{ color: "#919191" }}
              >
                More info on how IDVA can help you
              </p> */}
            </Container>
          </div>
          <AuthFooter />
        </div>
      </div>
    </div>
  );
};

export default ServiceList;
